import React from 'react'

import DataTable from '@/components/datatable/DataTable'
import TabTitle from '@/components/misc/CompanyProfile/components/TabTitle'
import { Badge } from '@/components/ui/badge'
import { Heading } from '@/components/ui/heading'
import {
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { CompanyProfileItemCompany } from '@/types/responses/companies'
interface Props {
  company: CompanyProfileItemCompany | null
  companyServices: CompanyProfileItemCompany['services']
  expertiseAreas: CompanyProfileItemCompany['expertiseAreas']
}

const FcaServicesAndExpertiseAreas: React.FC<Props> = ({
  company,
  companyServices,
  expertiseAreas,
}) => (
  <>
    <div className="mb-12">
      <TabTitle>
        This firm{' '}
        {company?.useSpecialisedWording ? 'specialises' : 'offers advice'} in
        the following areas:
      </TabTitle>

      <DataTable>
        <TableHeader>
          <TableRow>
            <TableHead>Area</TableHead>
            <TableHead>Independence</TableHead>
            <TableHead>Notes</TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {companyServices.map((service, key) => (
            <TableRow key={key}>
              <TableCell>{service.serviceAreaReadable}</TableCell>
              <TableCell>{service.serviceTypeReadable}</TableCell>
              <TableCell>{service.notes}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </DataTable>
    </div>

    {expertiseAreas.length > 0 && (
      <div className="mb-12">
        <Heading size={4}>Additional areas of expertise</Heading>

        <div className="flex flex-wrap gap-2">
          {expertiseAreas.map((area, key) => (
            <Badge variant="secondary" key={key} className="px-4 py-2">
              {area.name}
            </Badge>
          ))}
        </div>
      </div>
    )}
  </>
)

export default FcaServicesAndExpertiseAreas
